<template>
    <PageView>
        <a-card title="列表">
            <a-button type="primary" slot="extra" @click="$router.push({ name: `addprovider` })">添加小程序</a-button>
            <a-row :gutter="10" class="inputGroup">
                <a-col  :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.name" placeholder="小程序名称" @keyup.enter="getListTwo" />
                </a-col>
                <a-col  :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.app_id" placeholder="小程序ID" @keyup.enter="getListTwo" />
                </a-col>
                <a-col :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.shop_name" placeholder="主体名称" @keyup.enter="getListTwo" />
                </a-col>
                <a-col :xs="6" :md="3" :lg="3" :xl="2">
                    <a-input v-model="searchData.shop_account" placeholder="主体账号" @keyup.enter="getListTwo" />
                </a-col>
                <a-col  :xs="10" :md="4" :lg="4" :xl="2">
                    <a-select v-model="searchData.is_open_url" placeholder="跳转状态" style="width: 120px" allowClear>
                        <a-select-option :value="1">关闭</a-select-option>
                        <a-select-option :value="2">开启</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
                    <a-select v-model="searchData.is_jump_global" placeholder="全局状态" style="width: 100%" allowClear>
                        <a-select-option :value="1">只点击跳转</a-select-option>
                        <a-select-option :value="2">全局跳转</a-select-option>
                        <a-select-option :value="3">内页跳转</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
                    <a-select v-model="searchData.is_h5_jump" placeholder="H5状态" style="width: 100%" allowClear>
                        <a-select-option :value="1">关闭</a-select-option>
                        <a-select-option :value="2">开启</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3">
                    <a-select v-model="searchData.is_jietu" placeholder="首页展示模式" style="width: 100%" allowClear>
                        <a-select-option v-for="item in modeOptions" :key="item.value" :value="item.value">
                            {{ item.label }}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="6">
                    <a-button-group>
                        <a-button type="primary" :loading="loading" @click="getListTwo">确定筛选</a-button>
                    </a-button-group>
                    <a-button-group style="margin-left:10px">
                        <a-button type="primary" :loading="loading" @click="getListInit">重置</a-button>
                    </a-button-group>
                </a-col>
            </a-row>
            <div class="punish-summary">
                <div class="summary-card summary-card-today">
                    <div class="summary-label">今日处罚</div>
                    <div class="summary-value">{{ summary.today_count }}</div>
                    <div class="summary-desc">当天新增处罚记录</div>
                </div>
                <div class="summary-card summary-card-yesterday">
                    <div class="summary-label">昨日处罚</div>
                    <div class="summary-value">{{ summary.yesterday_count }}</div>
                    <div class="summary-desc">昨日处罚趋势</div>
                </div>
                <div class="summary-card summary-card-total">
                    <div class="summary-label">当前筛选总数</div>
                    <div class="summary-value">{{ summary.total_count }}</div>
                    <div class="summary-desc">随筛选条件实时变化</div>
                </div>
            </div>
            <a-table
                class="punish-table"
                :loading="loading"
                :columns="columns"
                :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }"
                @change="changePagination"
                :rowClassName="getRowClassName"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
        </a-card>

        <a-modal v-model="visible" title="Basic Modal" @ok="visible = false">
            <img :src="viewImg" style="width: 100%;" alt="" />
        </a-modal>
        <a-modal title="查看图片" :visible="ISimg" centered :closable="false" :maskClosable="false" width="600px">
            <img :src="imgUrl" alt="" style="width: 100%;height: 100%" />
            <template slot="footer">
                <a-button-group>
                    <a-button type="primary" @click="ISimg = false">确定</a-button>
                    <a-button type="default" @click="ISimg = false">关闭</a-button>
                </a-button-group>
            </template>
        </a-modal>
    </PageView>
</template>

<script type="text/jsx">
import Shop from '../../api/Shop.js'
var moment = require('moment')
const modeOptions = [
    { value: 1, label: '正常' },
    { value: 2, label: '截图' },
    { value: 3, label: '额度测算' },
    { value: 4, label: '计算器' },
    { value: 5, label: '比价' },
    { value: 6, label: '租超(拿手机号)' },
    { value: 7, label: '租超(直跳)' },
    { value: 8, label: '会展服务' },
    { value: 9, label: '3C数码维修' },
    { value: 10, label: '租机咨询(资讯)' },
    { value: 11, label: '网页模式' },
    { value: 12, label: '宝宝起名' },
    { value: 13, label: '个税计算神器' },
    { value: 14, label: '退休金计算神器' },
    { value: 15, label: '菜谱大全' },
    { value: 16, label: '开销记账神器' },
    { value: 17, label: '手机查询神器' },
]

const statusColorMap = {
    '处置生效中': '#f5222d',
    '已恢复': '#52c41a',
    '待处理': '#faad14',
}

export default {
    name: 'dealList',
    data () {
        return {
            loading: true,
            ISimg: false,
            imgUrl:'',
            modeOptions,
            sortField: undefined,
            sortOrder: undefined,
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                },
                {
                    title: '小程序信息',
                    dataIndex: 'from_app_name',
                    customRender: (text, record) => {
                        return (
                            <div class="merged-cell">
                                <div class="merged-title">
                                    <span class="merged-label merged-label-green">名称</span>
                                    <span>{text || '-'}</span>
                                </div>
                                <div class="merged-sub merged-sub-blue">
                                    <span class="merged-label merged-label-blue">APPID</span>
                                    <span>{record.from_app_id || '-'}</span>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    title: '版本号及版本状态',
                    dataIndex: 'version',
                },
                {
                    title: '数据源码',
                    dataIndex: 'code',
                },
                {
                    title: '跳转状态',
                    dataIndex: 'is_open_url',
                    customRender: (text, record) => {
                        if (!record.provider_id) return '--'
                        return (
                            <a-switch
                                checked={text === 2}
                                onChange={(checked) => this.handleStatusChange(checked, record.provider_id, 'is_open_url')}
                                checkedChildren="外跳"
                                unCheckedChildren="不外跳"
                                style={{
                                    backgroundColor: text === 2 ? '#1890ff' : undefined
                                }}
                            />
                        )
                    }
                },
                {
                    title: '全局状态',
                    dataIndex: 'is_jump_global',
                    customRender: (text, record) => {
                        if (!record.provider_id) return '--'
                        return (
                            <a-switch
                                checked={text === 2}
                                onChange={(checked) => this.handleStatusChange(checked, record.provider_id, 'is_jump_global')}
                                checkedChildren="全局跳转"
                                unCheckedChildren="只点击跳转"
                                style={{
                                    backgroundColor: text === 2 ? '#1890ff' : undefined
                                }}
                            />
                        )
                    }
                },
                {
                    title: 'h5状态',
                    dataIndex: 'is_h5_jump',
                    customRender: (text, record) => {
                        if (!record.provider_id) return '--'
                        return (
                            <a-switch
                                checked={text === 2}
                                onChange={(checked) => this.handleStatusChange(checked, record.provider_id, 'is_h5_jump')}
                                checkedChildren="开"
                                unCheckedChildren="关"
                                style={{
                                    backgroundColor: text === 2 ? '#1890ff' : undefined
                                }}
                            />
                        )
                    }
                },
                {
                    title: '首页展示模式',
                    dataIndex: 'is_jietu',
                    customRender: (text, record) => {
                        if (!record.provider_id) return '--'
                        return (
                            <a-select
                                value={text}
                                style={{ width: '140px' }}
                                onChange={(value) => this.handleModeChange(value, record.provider_id, 'is_jietu')}
                            >
                                {this.modeOptions.map(item => (
                                    <a-select-option key={item.value} value={item.value}>
                                        {item.label}
                                    </a-select-option>
                                ))}
                            </a-select>
                        )
                    }
                },
                {
                    title: '主体信息',
                    dataIndex: 'shop_name',
                    customRender: (text, record) => {
                        return (
                            <div class="merged-cell">
                                <div class="merged-title">{text || '-'}</div>
                                <div class="merged-sub merged-sub-blue">{record.shop_account || '未配置主体账号'}</div>
                            </div>
                        )
                    }
                },
                {
                    title: '问题信息',
                    dataIndex: 'question_type',
                    customRender: (text, record) => {
                        return (
                            <div class="merged-cell merged-cell-wide">
                                <div class="merged-title">
                                    <span class="merged-label merged-label-orange">类型</span>
                                    <span>{text || '-'}</span>
                                </div>
                                <div class="merged-sub">
                                    <span class="merged-label merged-label-gray">描述</span>
                                    <span>{record.question_desc || '-'}</span>
                                </div>
                            </div>
                        )
                    }
                },
                {
                    title: '处置状态',
                    dataIndex: 'status',
                    customRender: (text) => {
                        const color = statusColorMap[text] || '#595959'
                        return <span style={{ color, fontWeight: 600 }}>{text || '-'}</span>
                    }
                },
                {
                    title: '处置时间',
                    dataIndex: 'oper_time',
                    sorter: true,
                },
                {
                    title: '初次巡检时间',
                    dataIndex: 'add_time',
                    sorter: true,
                },
                {
                    title: '最近巡检时间',
                    dataIndex: 'update_time',
                    sorter: true,
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-button-group>
                                <a-button
                                    type="primary"
                                    onClick={()=>{
                                        if (!v.provider_id && !v.from_app_id) return
                                        this.$router.push({name:`addprovider`,query: { id: v.provider_id || v.from_app_id}})
                                    }}>
                                    快捷编辑小程序
                                </a-button>
                            </a-button-group>
                        )

                    }
                }
            ],
            data: [],

            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            summary: {
                today_count: 0,
                yesterday_count: 0,
                total_count: 0,
            },
            searchData: {
                name: '',
                app_id: '',
                shop_name: '',
                shop_account: '',
                is_open_url: undefined,
                is_jump_global: undefined,
                is_h5_jump: undefined,
                is_jietu: undefined,
            },
            time: [],
            visible: false,
            viewImg: '',
            timeRange: [],
            newTime:[],
        }
    },
    activated () {
        this.getList()
    },
    methods: {
        handleRangeChange(value) {
            if (Array.isArray(value) && value.length === 2) {
                    const validDates = value.every(date => date instanceof moment || date instanceof Date);
                    if (validDates) {
                        this.timeRange = value;
                        const startTimeStamp = moment(this.timeRange[0]).valueOf();
                        const endTimeStamp = moment(this.timeRange[1]).valueOf();
                        this.newTime = [parseInt(startTimeStamp/1000),parseInt(endTimeStamp/1000)]
                        this.getList(this.newTime)
                    }
            } else {
                this.newTime =[];
                this.getList(this.newTime)
            }

        },
      getListInit(){
        this.searchData = {
            name: '',
            app_id: '',
            shop_name: '',
            shop_account: '',
            is_open_url: undefined,
            is_jump_global: undefined,
            is_h5_jump: undefined,
            is_jietu: undefined,
        }
        this.sortField = undefined
        this.sortOrder = undefined
        this.current = 1
        this.getList()
      },

        getListTwo () {
            this.current = 1
            this.getList()
        },
        getList (time) {
            this.loading = true
            Shop.punishList({
                page: this.current,
                num: this.pageSize,
                ...this.searchData,
                sort_field: this.sortField,
                sort_order: this.sortOrder,
                time:time
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key }
                })
                this.summary = res.summary || {
                    today_count: 0,
                    yesterday_count: 0,
                    total_count: parseInt(res.count || 0),
                }
                this.loading = false
                this.total = parseInt(res.count)
            })
        },
        changePagination (pagination, filters, sorter) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            if (sorter && sorter.field) {
                this.sortField = sorter.field
                this.sortOrder = sorter.order
            } else {
                this.sortField = undefined
                this.sortOrder = undefined
            }
            this.getList()
        },
        handleStatusChange(checked, id, field) {
            const status = checked ? 2 : 1
            this.loading = true
            Shop.UpdateProviderStatus({
                id,
                [field]: status
            }).then(res => {
                if (res.status == 1) {
                    const index = this.data.findIndex(item => item.provider_id === id)
                    if (index !== -1) {
                        this.$set(this.data, index, {
                            ...this.data[index],
                            [field]: status
                        })
                    }
                } else {
                    this.$message.error(res.msg || '状态更新失败')
                }
            }).catch(() => {
                this.$message.error('状态更新失败')
            }).finally(() => {
                this.loading = false
            })
        },
        handleModeChange(value, id, field) {
            this.loading = true
            Shop.UpdateProviderStatus({
                id,
                [field]: value
            }).then(res => {
                if (res.status == 1) {
                    const index = this.data.findIndex(item => item.provider_id === id)
                    if (index !== -1) {
                        this.$set(this.data, index, {
                            ...this.data[index],
                            [field]: value
                        })
                    }
                } else {
                    this.$message.error(res.msg || '展示模式更新失败')
                }
            }).catch(() => {
                this.$message.error('展示模式更新失败')
            }).finally(() => {
                this.loading = false
            })
        },
        parseRowTime(record) {
            const source = record.oper_time && record.oper_time !== '-' ? record.oper_time : record.add_time
            if (!source || source === '-') return 0
            const time = new Date(String(source).replace(/-/g, '/')).getTime()
            return Number.isNaN(time) ? 0 : time
        },
        getRowClassName(record) {
            const rowTime = this.parseRowTime(record)
            if (!rowTime) return ''
            const now = Date.now()
            const today = new Date()
            today.setHours(0, 0, 0, 0)
            const todayStart = today.getTime()
            const yesterdayStart = todayStart - 24 * 60 * 60 * 1000
            if (rowTime >= todayStart && rowTime <= now) return 'punish-row-today'
            if (rowTime >= yesterdayStart && rowTime < todayStart) return 'punish-row-yesterday'
            if (rowTime >= todayStart - 3 * 24 * 60 * 60 * 1000) return 'punish-row-recent'
            return 'punish-row-history'
        },

    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}

.punish-summary {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    margin-bottom: 18px;
}

.summary-card {
    position: relative;
    overflow: hidden;
    padding: 18px 20px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.92);
    box-shadow: 0 8px 24px rgba(31, 35, 41, 0.06);
}

.summary-card::after {
    content: '';
    position: absolute;
    top: -12px;
    right: -12px;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    opacity: .28;
}

.summary-card-today {
    background: rgba(255, 244, 230, 0.9);
}

.summary-card-today::after {
    background: #fa8c16;
}

.summary-card-yesterday {
    background: rgba(230, 247, 255, 0.9);
}

.summary-card-yesterday::after {
    background: #1890ff;
}

.summary-card-total {
    background: rgba(246, 255, 237, 0.92);
}

.summary-card-total::after {
    background: #52c41a;
}

.summary-label {
    position: relative;
    z-index: 1;
    font-size: 13px;
    color: #595959;
}

.summary-value {
    position: relative;
    z-index: 1;
    margin-top: 8px;
    font-size: 28px;
    line-height: 1.2;
    font-weight: 700;
    color: #262626;
}

.summary-desc {
    position: relative;
    z-index: 1;
    margin-top: 8px;
    font-size: 12px;
    color: #8c8c8c;
}

.merged-cell {
    min-width: 150px;
}

.merged-cell-wide {
    min-width: 220px;
}

.merged-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    color: #262626;
    font-weight: 600;
    line-height: 1.5;
}

.merged-sub {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 6px;
    font-size: 12px;
    line-height: 1.5;
    color: #8c8c8c;
}

.merged-sub-blue {
    color: #1677ff;
}

.merged-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    height: 22px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    line-height: 22px;
}

.merged-label-green {
    color: #1f8f55;
    background: #edf9f1;
}

.merged-label-blue {
    color: #1677ff;
    background: #eaf3ff;
}

.merged-label-orange {
    color: #d46b08;
    background: #fff4e6;
}

.merged-label-gray {
    color: #595959;
    background: #f5f5f5;
}

/deep/ .punish-table .punish-row-today > td {
    background: rgba(255, 229, 143, 0.26) !important;
}

/deep/ .punish-table .punish-row-yesterday > td {
    background: rgba(255, 244, 230, 0.18) !important;
}

/deep/ .punish-table .punish-row-recent > td {
    background: rgba(230, 247, 255, 0.12) !important;
}

/deep/ .punish-table .punish-row-history > td {
    background: rgba(255, 255, 255, 0.92) !important;
}

</style>
